import { render, staticRenderFns } from "./news-view-page.vue?vue&type=template&id=ac441618&"
import script from "./news-view-page.vue?vue&type=script&lang=js&"
export * from "./news-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports